<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App"
}
</script>

<style lang="less">
.swiper-pagination-bullet {
    width: 20px !important;
    border-radius: 0 !important;
}
</style>
